import { ZendeskAPI } from 'react-zendesk';
import { call, select, takeEvery, all } from 'redux-saga/effects';

import ZendeskTokenAPI from '../api/ZendeskTokenAPI';
import { ZENDESK_LOGIN_USER } from '../constants/actionTypes';
import { track } from '../lib/heapHelpers';
import { accessTokenSelector, customerGuidSelector, emailSelector } from '../reducers/selectors';

function* zendeskWatcher() {
  yield takeEvery(ZENDESK_LOGIN_USER, zendeskLoginUserWorker);
}

const ZENDESK_FIELD_APP_ID = process.env.REACT_APP_ZENDESK_FIELD_APP_ID;

const setAppIdConversationField = appIdField => {
  if (!appIdField) return;

  const urlPath = window.location.pathname;
  const regex = /\/provisional-offer\/([^/]+)\/?/;
  const match = urlPath.match(regex);

  if (match && match[1]) {
    ZendeskAPI('messenger:set', 'conversationFields', [{ id: appIdField, value: match[1] }]);
  }
};

const removeAppIdConversationField = appIdField => {
  if (!appIdField) return;

  ZendeskAPI('messenger:set', 'conversationFields', [{ id: appIdField, value: '' }]);
};

const initializeZendeskOpenFunctionality = () => {
  ZendeskAPI('messenger:on', 'open', () => {
    track('Click - Widget Open');
    setAppIdConversationField(ZENDESK_FIELD_APP_ID);
  });
};

const initializeZendeskCloseFunctionality = () => {
  ZendeskAPI('messenger:on', 'close', () => {
    track('Click - Widget Close');
    removeAppIdConversationField(ZENDESK_FIELD_APP_ID);
  });
};

function* zendeskLoginUserWorker() {
  const [customerGuid, email, accessToken] = yield all([
    select(customerGuidSelector),
    select(emailSelector),
    select(accessTokenSelector),
  ]);

  const { token } = yield call(ZendeskTokenAPI.getZendeskToken, customerGuid, accessToken, email);
  try {
    yield call(ZendeskAPI, 'messenger', 'loginUser', callback => callback(token));
    yield call(initializeZendeskOpenFunctionality);
    yield call(initializeZendeskCloseFunctionality);
  } catch (e) {
    console.log('Zendesk messenger not available');
  }
}

export {
  zendeskLoginUserWorker,
  initializeZendeskOpenFunctionality,
  setAppIdConversationField,
  removeAppIdConversationField,
  initializeZendeskCloseFunctionality,
};
export default zendeskWatcher;
